import { Scatter } from 'vue-chartjs'

export default {
  extends: Scatter,
  props: {
    chartdata: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  watch: {
    chartdata: function () {
      this.renderChart(this.chartdata, this.options)
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/components/charts/scatter.js